<div id="icons" class="page-layout simple tabbed" fxLayout="column">
    <!-- CONTENT -->
    <div class="content p-24">
        <div>
            <div fxLayout="column">
                <div fxLayout="row wrap">

                    <a routerLink="/users" *appIsGranted="['Workers', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">assignment_ind</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Workers'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/trainers" *appIsGranted="['Workers', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">accessibility</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Trainers'|translate}}
                            </div>
                        </div>
                    </a>

<!--                    <a routerLink="/groups">-->
<!--                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">-->
<!--                            <mat-icon class="secondary-text s-48">person</mat-icon>-->
<!--                            <div class="icon-name secondary-text mt-8">-->
<!--                                {{'Groups'|translate}}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </a>-->

                    <a routerLink="/operators" *appIsGranted="['Operators', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">location_city</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Operators'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/settings/resources" *appIsGranted="['Resources', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">devices_other</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Devices'|translate}}/{{'Resources'|translate}}
                            </div>
                        </div>
                    </a>

<!--                    <a routerLink="/device-groups">-->
<!--                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">-->
<!--                            <mat-icon class="secondary-text s-48">ballot</mat-icon>-->
<!--                            <div class="icon-name secondary-text mt-8">-->
<!--                                {{'Device groups'|translate}}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </a>-->

                    <a routerLink="/customer-sources" *appIsGranted="['Customer sources', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">call_merge</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Customer source'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/settings/vat-rates" *appIsGranted="['VAT rates', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">public</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Vat rates'|translate}}
                            </div>
                        </div>
                    </a>

<!--                    <a routerLink="/settings/resources">-->
<!--                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">-->
<!--                            <mat-icon class="secondary-text s-48">account_balance</mat-icon>-->
<!--                            <div class="icon-name secondary-text mt-8">-->
<!--                                {{'Resources'|translate}}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </a>-->

                    <a routerLink="/settings/voucher-templates" *appIsGranted="['Voucher templates', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">cake</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Voucher templates'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/actions" *appIsGranted="['Marketing vouchers', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">stars</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Marketing vouchers'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/public-api-accesses" *appIsGranted="['Public API access', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">compare_arrows</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Public API access'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/message-templates" *appIsGranted="['Message templates', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">code</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Message templates'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/notification-accounts" *appIsGranted="['Notification accounts', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">contact_mail</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Notification accounts'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/notifications" *appIsGranted="['Notifications', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">assignment_late</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Notifications'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/marketing-actions" *appIsGranted="['Marketing actions', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">shopping_basket</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Marketing actions'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/settings/security/module-permissions" *appIsGranted="['Security', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">lock</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Security'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/cms">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">pages</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'CMS'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/files">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">folder</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Files'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/settings/discounts" *appIsGranted="['Discount', 'ANY']">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">money</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Discounts'|translate}}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
